import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { half } = measures

export const reportHeader = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${2 * half}px;
  flex-wrap: wrap;
  margin-bottom: ${3 * half}px;
`

export const reportTitle = css`
  flex: 0 0 240px;
`

export const reportFilters = css`
  flex: 1 1 640px;
  min-width: 0;
`

export const reportTable = css`
  display: flex;
  flex-direction: column;
  gap: ${2 * half}px;
`
